export const LocalStorage = {
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        const item = localStorage.getItem(key);

        if (item === null) {
            return null;
        }

        try {
            return JSON.parse(item);
        } catch (e) {
            log.error(`Could not parse local storage item: '${key}'`, e);
            return null;
        }
    },
}